module.exports = __webpack_public_path__ + "assets/warning.mp3";